const errorFragment = `
  field
  message
`;

const productFragment = `
  id
  title
  productType
  isGiftCard
  onlineStoreUrl
  featuredImage {
    url
    id
    width
    height
    altText
  }
  tags
  images(first: 5) {
    edges {
      node {
        url
      }
    }
  }
`;

const productVariantFragment = `
  id
  title
  sku
  image {
    url
  }
  compareAtPrice {
    amount
  }
  selectedOptions {
    name
    value
  }
  availableForSale
  product {
    ${productFragment}
  }
  price {
    amount
  }
`;

const cartFragment = `
  id
  createdAt
  updatedAt
  totalQuantity
  checkoutUrl
  lines(first: 50) {
    edges {
      node {
        id
        quantity
        merchandise {
          ... on ProductVariant {
            ${productVariantFragment}
          }
        }
        attributes {
          key
          value
        }
        discountAllocations {
          discountedAmount {
            amount
          }
          targetType
        }
      }
    }
  }
  attributes {
    key
    value
  }
  discountCodes {
    code
    applicable
  }
  discountAllocations {
    discountedAmount {
      amount
    }
  }
  cost {
    totalAmount {
      amount
      currencyCode
    }
    subtotalAmount {
      amount
      currencyCode
    }
  }
`;

// Queries
export const cartCreateQuery = `
  mutation CreateCart {
    cartCreate {
      cart {
        checkoutUrl
        id
      }
    }
  }
`;

export const fetchCartQuery = (cartToken) =>
  `
    query {
      cart(
        id: "${cartToken}"
      ) {
        ${cartFragment}
      }
    }
  `;

export const productVariantQuery = (variantId) => `
    query {
      node(id: "${variantId}") {
        ... on ProductVariant {
          ${productVariantFragment}
        }
      }
    }
  `;

export const addToStorefrontCartQuery = `
  mutation AddLinesToCart($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cart {
        ${cartFragment}
      }
      userErrors {
        ${errorFragment}
      }
    }
  }
`;

export const removeFromStorefrontCartQuery = `
  mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      cart {
        ${cartFragment}
      }
      userErrors {
        ${errorFragment}
      }
    }
  }
`;

export const updateCartLineQuery = `
    mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
      cartLinesUpdate(cartId: $cartId, lines: $lines) {
        cart {
          ${cartFragment}
        }
        userErrors {
          ${errorFragment}
        }
      }
    }
  `;

export const updateCartAttributesQuery = `
  mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $cartId: ID!) {
    cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
      cart {
        ${cartFragment}
      }
      userErrors {
        ${errorFragment}
      }
    }
  }
`;
